import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { isNil } from 'lodash';
import { mergeQueryParams, pickQueryParams } from 'modules/taboola-common-frontend-modules/query-params';
import { useNavigate, ACCOUNT_ID } from '../../../hooks';
import { AllEntityId } from '../../../modules/campaigns/config/allEntityId';
import { REPORT_ENTITY_IDS } from '../../../modules/campaigns/hooks/useReportEntityIds';
import { REPORT_ENTITY_TYPE } from '../../../modules/campaigns/hooks/useReportEntityType';

/*** Generic hook for handling breadcrumb navigation (Keyboard or Mouse events)*/
export const useBreadcrumbNavigation = ({ entityType, paramsToKeep, closeDropdown, selectedItem }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = useCallback(
        selectedOption => {
            const id = selectedOption?.id;
            if (closeDropdown) {
                closeDropdown();
            }
            if (isNil(id) || id === selectedItem?.id) {
                return;
            }

            const locationWithRequiredParams = pickQueryParams(paramsToKeep);
            const params = isNil(entityType)
                ? {
                      [ACCOUNT_ID]: id,
                      [REPORT_ENTITY_IDS]: AllEntityId,
                      [REPORT_ENTITY_TYPE]: AllEntityId,
                  }
                : {
                      [REPORT_ENTITY_TYPE]: id === AllEntityId ? AllEntityId : entityType,
                      [REPORT_ENTITY_IDS]: id,
                  };

            const search = mergeQueryParams(locationWithRequiredParams, params);
            navigate(`${location.pathname}${search}`);
        },
        [closeDropdown, navigate, location, entityType, paramsToKeep, selectedItem]
    );
    return handleNavigation;
};
